<template>
  <v-dialog
    max-width="440"
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card class="about-card pa-4 text-center" :style="aboutCardStyle">
      <v-card-text>
        <v-img class="mb-4" height="120" :src="logoUrl" />
        <div class="text-headline-medium font-weight-bold">{{ APP_NAME }}</div>
        <div class="text-headline-small mb-4">{{ APP_VERSION }}</div>
        <div class="text-body-large mb-0">Author: {{ APP_AUTHOR }}&trade;</div>
        <div class="text-body-small text-grey">{{ APP_LICENSE }}</div>
        <div class="mt-4"><MadeWithLove /></div>
      </v-card-text>

      <v-card-actions v-if="APP_ISSUES_URL" class="justify-center">
        <v-btn
          color="primary"
          :href="APP_ISSUES_URL"
          prepend-icon="mdi-alert-circle-outline"
          size="small"
          target="_blank"
          variant="tonal"
        >
          Report an issue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
  import {
    APP_AUTHOR,
    APP_ISSUES_URL,
    APP_LICENSE,
    APP_NAME,
    APP_VERSION,
  } from '#xapp-core/foundation/config/appMeta'
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'

  import logoBlackUrl from '../assets/x-logo-black.svg'
  import logoWhiteUrl from '../assets/x-logo-white.svg'

  defineProps({
    modelValue: Boolean,
  })

  const emit = defineEmits(['update:modelValue'])
  const theme = useTheme()
  const logoUrl = computed(() =>
    theme.global.current.value.dark ? logoWhiteUrl : logoBlackUrl
  )
  const aboutCardStyle = computed(() => ({
    border: `1px solid ${
      theme.global.current.value.dark
        ? 'rgba(255, 255, 255, 0.35)'
        : 'rgba(0, 0, 0, 0.35)'
    }`,
  }))
</script>

<style scoped>
  .about-card {
    border-radius: 36px !important;
  }
</style>
